import styled from "@emotion/styled";
import { motion, space } from "@smartsheet/design-tokens";
export const ToastContainerStyled = styled("div")`
    transition: opacity ${motion.animation.default}, transform ${motion.animation.default};

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;

    // We attach this so we can capture the mouse enter events between the toasts themselves.
    // This is necessary to prevent the auto-close timer from firing when the user is interacting
    // with the toast stack.
    padding-top: ${space.space30};

    width: var(--sds-toast--container-width, 450px);
`;
//# sourceMappingURL=ToastContainerStyled.js.map